<template>
  <div class="text-block block-card card-border big-card-block">
    <v-expansion-panel 
      :value="panel" 
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <img 
                src="../../../../assets/img/airplane.png" 
                alt="">
            </div>

            <h4>
              Flight 
              <v-icon 
                v-if = "errorsCount && errorsCount.errorsCount" 
                color = "error" 
                style = "margin-left: 4px;">error</v-icon>
            </h4>
          </div>
        </template>
        <form-validation v-model = "errorsCount">
          <div class="block-card-body px-4 pb-4" v-if="validData">
            
            <div class="flight-type-toggle mb-5 d-flex">
              <div class="toggle-container" style="background: #F4F6F8; border-radius: 8px; padding: 4px; display: inline-flex;">
                <div 
                  class="toggle-btn px-4 py-2 d-flex align-center cursor-pointer" 
                  :style="flightType === 'arrivals' ? 'background: white; border-radius: 6px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);' : 'color: #6B7280;'"
                  @click.stop="flightType = 'arrivals'"
                >
                  <v-icon small class="mr-2" :color="flightType === 'arrivals' ? 'black' : '#6B7280'">flight_land</v-icon>
                  <span :style="flightType === 'arrivals' ? 'font-weight: 600; color: black; font-size: 14px;' : 'font-size: 14px;'">Arrivals</span>
                </div>
                <div 
                  class="toggle-btn px-4 py-2 d-flex align-center cursor-pointer" 
                  :style="flightType === 'departure' ? 'background: white; border-radius: 6px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);' : 'color: #6B7280;'"
                  @click.stop="flightType = 'departure'"
                >
                  <v-icon small class="mr-2" :color="flightType === 'departure' ? 'black' : '#6B7280'">flight_takeoff</v-icon>
                  <span :style="flightType === 'departure' ? 'font-weight: 600; color: black; font-size: 14px;' : 'font-size: 14px;'">Departure</span>
                </div>
              </div>
            </div>

            <v-layout row wrap class="form-grid">
              <v-flex xs12 sm6 class="px-2 mb-4">
                <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Airline</label>
                <vTextareaAutocomplete 
                  v-model="data.airline" 
                  :type="'textfield'"
                  placeholder="Airline"
                  :validation-rules="[v => !!v || 'Airline is Required']" />
              </v-flex>

              <v-flex xs12 sm6 class="px-2 mb-4">
                <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Flight Number</label>
                <vTextareaAutocomplete 
                  v-model="data.flight" 
                  :type="'textfield'"
                  placeholder="e.g. SK-402"
                  :validation-rules="[v => !!v || 'Flight Number is Required']" />
              </v-flex>

              <template v-if="flightType === 'arrivals'">
                <v-flex xs12 sm6 class="px-2 mb-4">
                  <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Scheduled Arrival Time</label>
                  <vTextareaAutocomplete
                    v-model="data.sch_arrives_time"
                    :type="'textfield'"
                    placeholder="--:-- --"
                    :validation-rules="[v => !!v || 'Scheduled arrival time is Required']"
                  />
                </v-flex>

                <v-flex xs12 sm6 class="px-2 mb-4">
                  <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Scheduled Arrival Date</label>
                  <vTextareaAutocomplete
                    v-model="data.sch_arrives_date"
                    :type="'textfield'"
                    placeholder="DD/MM/YY"
                    :validation-rules="[v => !!v || 'Scheduled arrival date is Required']"
                  />
                </v-flex>

                <v-flex xs12 sm6 class="px-2 mb-4">
                  <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Estimated Arrival Time</label>
                  <vTextareaAutocomplete
                    v-model="data.est_arrives_time"
                    :type="'textfield'"
                    placeholder="--:-- --"
                    :validation-rules="[v => !!v || 'Estimated arrival time is Required']"
                  />
                </v-flex>

                <v-flex xs12 sm6 class="px-2 mb-4">
                  <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Estimated Arrival Date</label>
                  <vTextareaAutocomplete
                    v-model="data.est_arrives_date"
                    :type="'textfield'"
                    placeholder="DD/MM/YY"
                    :validation-rules="[v => !!v || 'Estimated arrival date is Required']"
                  />
                </v-flex>
              </template>

              <template v-else>
                <v-flex xs12 sm6 class="px-2 mb-4">
                  <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Scheduled Departure Time</label>
                  <vTextareaAutocomplete
                    v-model="data.sch_departs_time"
                    :type="'textfield'"
                    placeholder="--:-- --"
                    :validation-rules="[v => !!v || 'Scheduled departure time is Required']"
                  />
                </v-flex>

                <v-flex xs12 sm6 class="px-2 mb-4">
                  <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Scheduled Departure Date</label>
                  <vTextareaAutocomplete
                    v-model="data.sch_departs_date"
                    :type="'textfield'"
                    placeholder="DD/MM/YY"
                    :validation-rules="[v => !!v || 'Scheduled departure date is Required']"
                  />
                </v-flex>

                <v-flex xs12 sm6 class="px-2 mb-4">
                  <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Estimated Departure Time</label>
                  <vTextareaAutocomplete
                    v-model="data.est_departs_time"
                    :type="'textfield'"
                    placeholder="--:-- --"
                    :validation-rules="[v => !!v || 'Estimated departure time is Required']"
                  />
                </v-flex>

                <v-flex xs12 sm6 class="px-2 mb-4">
                  <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Estimated Departure Date</label>
                  <vTextareaAutocomplete
                    v-model="data.est_departs_date"
                    :type="'textfield'"
                    placeholder="DD/MM/YY"
                    :validation-rules="[v => !!v || 'Estimated departure date is Required']"
                  />
                </v-flex>
              </template>

              <v-flex xs12 sm5 class="px-2 mb-4">
                <div>
                  <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Origin</label>
                  <vTextareaAutocomplete 
                    v-model="data.travel.originName" 
                    :type="'textfield'"
                    placeholder="From"
                    :validation-rules="[v => !!v || 'Origin Name is Required']" />
                </div>
                <div>
                  <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Origin Code</label>
                  <vTextareaAutocomplete 
                    v-model="data.travel.originAcronym" 
                    :type="'textfield'"
                    placeholder="Origin Code"
                    :validation-rules="[v => !!v || 'Origin Code is Required']" />
                </div>
              </v-flex>

              <v-flex xs12 sm2 class="d-flex align-center justify-center mb-4 mt-4">
                <v-icon color="grey">arrow_forward</v-icon>
              </v-flex>

              <v-flex xs12 sm5 class="px-2 mb-4">
                <div>
                  <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Destination</label>
                  <vTextareaAutocomplete 
                    v-model="data.travel.destName" 
                    :type="'textfield'"
                    placeholder="To"
                    :validation-rules="[v => !!v || 'Destination Name is Required']" />
                </div>
                <div>
                  <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Destination Code</label>
                  <vTextareaAutocomplete 
                    v-model="data.travel.destAcronym" 
                    :type="'textfield'"
                    placeholder="Destination Code"
                    :validation-rules="[v => !!v || 'Destination Code is Required']" />
                </div>
              </v-flex>

              <v-flex v-if="flightType === 'arrivals'" xs12 sm6 class="px-2 mb-4">
                <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Carousel / Belt</label>
                <vTextareaAutocomplete 
                  v-model="data.carousel" 
                  :type="'textfield'"
                  placeholder="e.g. 05-B"
                  :validation-rules="[v => !!v || 'Carousel is Required']" />
              </v-flex>

              <v-flex xs12 sm6 class="px-2 mb-4">
                <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Current Flight Status</label>
                <vTextareaAutocomplete 
                  v-model="data.status" 
                  :type="'textfield'"
                  placeholder="e.g. SK-402"
                  :validation-rules="[v => !!v || 'Status is Required']" />
              </v-flex>

              <v-flex v-if="flightType === 'departure'" xs12 sm6 class="px-2 mb-4">
                <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Check in</label>
                <vTextareaAutocomplete 
                  v-model="data.checkin" 
                  :type="'textfield'"
                  placeholder="e.g. A12"
                  :validation-rules="[v => !!v || 'Check in is Required']" />
              </v-flex>

              <v-flex v-if="flightType === 'departure'" xs12 sm6 class="px-2 mb-4">
                <label class="custom-label font-weight-bold mb-2 d-block" style="font-size: 13px;">Gate</label>
                <vTextareaAutocomplete 
                  v-model="data.gate" 
                  :type="'textfield'"
                  placeholder="e.g. B3"
                  :validation-rules="[v => !!v || 'Gate is Required']" />
              </v-flex>
            </v-layout>

            

          </div>
        </form-validation>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from '../../../../utils/common'
import FormValidation from '../FormValidation'
export default {
  name: 'CardFlight',
  components: {
    FormValidation
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    },
    blocksList: {
      type: Array,
      default: () => {
        return []
      }
    },
    validData: {
      type: Boolean,
      default: ()=> {
        return false
      }
    }
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common,
      flightType: 'arrivals'
    }
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit('input', { errorsCount: val.errorsCount })
      this.data.errorsCount = val.errorsCount
    },
    flightType(val) {
      this.$set(this.data, 'type', val)
    }
  },
  mounted() {
    if (!this.data.travel) {
      this.$set(this.data, 'travel', {})
    }

    const setIfMissing = (key, value) => {
      if (!this.data.hasOwnProperty(key) || this.data[key] === null) {
        this.$set(this.data, key, value)
      }
    }

    const setIfEmpty = (key, value) => {
      if (this.data[key] === undefined || this.data[key] === null || this.data[key] === '') {
        this.$set(this.data, key, value)
      }
    }

    setIfMissing('type', this.flightType)
    setIfMissing('airline', '')
    setIfMissing('checkin', '')
    setIfMissing('gate', '')
    setIfMissing('carousel', '')
    setIfMissing('sch_arrives_time', '')
    setIfMissing('sch_arrives_date', '')
    setIfMissing('est_arrives_time', '')
    setIfMissing('est_arrives_date', '')
    setIfMissing('sch_departs_time', '')
    setIfMissing('sch_departs_date', '')
    setIfMissing('est_departs_time', '')
    setIfMissing('est_departs_date', '')

    if (this.data.type === 'departure') {
      this.flightType = 'departure'
    } else if (this.data.type === 'arrival' || this.data.type === 'arrivals') {
      this.flightType = 'arrivals'
    } else {
      this.$set(this.data, 'type', this.flightType)
    }

    if (this.flightType === 'arrivals') {
      if (this.data.arrives !== undefined && this.data.arrives !== null && this.data.arrives !== '') {
        setIfEmpty('sch_arrives_time', this.data.arrives)
        setIfEmpty('est_arrives_time', this.data.arrives)
      }
      if (this.data.date !== undefined && this.data.date !== null && this.data.date !== '') {
        setIfEmpty('sch_arrives_date', this.data.date)
        setIfEmpty('est_arrives_date', this.data.date)
      }
    } else {
      if (this.data.departs !== undefined && this.data.departs !== null && this.data.departs !== '') {
        setIfEmpty('sch_departs_time', this.data.departs)
        setIfEmpty('est_departs_time', this.data.departs)
      }
      if (this.data.date !== undefined && this.data.date !== null && this.data.date !== '') {
        setIfEmpty('sch_departs_date', this.data.date)
        setIfEmpty('est_departs_date', this.data.date)
      }
    }

    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
  },
  methods: {}
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.custom-label {
  color: #111827;
}
</style>
